module.exports = __webpack_public_path__ + "safari-pinned-tab.3999b2bb.svg";